export const convertKeywordsToString = (keywords: string[] | undefined) => {
  if (!keywords) return ''
  let str = ''
  keywords.forEach((word, i) => {
    if (i + 1 === keywords.length) {
      str += word
    } else {
      str += word + ', '
    }
  })

  return str
}
